// ! if statement below causes issues with rendering Shopify Forms input fields
if (
  document.getElementsByClassName("template-product").length == 0 &&
  document.getElementsByClassName("template-teethoftomorrow").length == 0
) {
  const insertBeforeElementBackup = Element.prototype.insertBefore;
  Element.prototype.insertBefore = function (...args) {
    if (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") == -1) {
      return insertBeforeElementBackup.apply(this, args);
    }
  };
}
// !!!!!

//prevent load font awesome  from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild = function (...args) {
  if (
    args[0].nodeName &&
    args[0].nodeName == "SCRIPT" &&
    args[0].src.indexOf("jquery.min.js") != -1
  ) {
    if (window.SPR != undefined) {
      $.ajaxSetup({ cache: !0 }),
        SPR.loadjQueryExtentions($),
        $(document).ready(function () {
          SPR.$ = jQuery;
          return (
            SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          );
        });
    }
    return;
  }
  if (
    !args[0].outerHTML ||
    (args[0].outerHTML &&
      args[0].outerHTML.indexOf(
        "maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css"
      ) == -1)
  )
    return appendElementBackup.apply(this, args);
};

if (
  $(
    'link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]'
  ).length > 0
)
  $(
    'link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]'
  ).remove();

var W_width = $(window).width(),
  W_height = $(window).height();
$(window).on("resize", function () {
  if ($(window).width() != W_width || $(window).height() != W_height) {
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on("load", function () {
  _initResize();
});

// Filters
function _initResize() {
  initSwatches();
  $(".filter-refine").off("click");
  $(".filter-overlay, .filter__close, .filter__apply").off("click");
  $(".filter-sort__title").off("click");
  $(document).off("click.resize");
  $(".filter-sort-overlay").removeClass("filter-sort-overlay--active");
  $(".filters__container").removeClass("filters__container--sticky");
  $("html").removeClass("no-scroll");
  $(".filter-sort__list").css("display", "");
  $(".filter-sort").off("click");
  // Filters Mobile/Tablet
  if ($(window).width() < 1365) {
    // Filters - Open
    $(".filter-refine").on("click", function () {
      $(".filter").toggleClass("filter--active");
      $(".filters__container").removeClass("filters__container--sticky");
      $(".filter-overlay").addClass("filter-overlay--active");
      $("html").addClass("no-scroll");
      return false;
    });

    // Filter - Close
    $(".filter-overlay, .filter__close, .filter__apply").on(
      "click",
      function () {
        $(".filter").removeClass("filter--active");
        $(".filter-overlay").removeClass("filter-overlay--active");
        $("html").removeClass("no-scroll");
        return false;
      }
    );
  }

  // Sort Tablet/Desktop
  if ($(window).width() > 599) {
    $(".filter-sort__title").on("click", function (e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.next().hasClass("filter-sort__list--active")) {
        $this.next().removeClass("filter-sort__list--active");
        $this.next().slideUp(150);
      } else {
        $this
          .parent()
          .parent()
          .find(".filter-sort .filter-sort__list")
          .removeClass("filter-sort__list--active");
        $this
          .parent()
          .parent()
          .find(".filter-sort .filter-sort__list")
          .slideUp(150);
        $this.next().toggleClass("filter-sort__list--active");
        $this.next().slideToggle(150);
      }

      if ($this.hasClass("filter-sort__title--active")) {
        $this.removeClass("filter-sort__title--active");
      } else {
        $this
          .parent()
          .find(".filter-sort .filter__title")
          .removeClass("filter-sort__title--active");
        $this.toggleClass("filter-sort__title--active");
      }
    });

    $(document).on("click.resize", function (e) {
      if (!$(e.target).is(".filter-sort *")) {
        $(".filter-sort__list").removeClass("filter-sort__list--active");
        $(".filter-sort__title").removeClass("filter-sort__title--active");
        $(".filter-sort__list").slideUp(150);
      }
    });
  }

  // Sort Mobile
  if ($(window).width() < 600) {
    $(".filter-sort").on("click", function () {
      $(this)
        .children(".filter-sort__list")
        .toggleClass("filter-sort__list--active");
      $(".filter-sort-overlay").toggleClass("filter-sort-overlay--active");
      $(".filters__container").removeClass("filters__container--sticky");
      $("html").toggleClass("no-scroll");
      return false;
    });
    $(document).on("click.resize", function (e) {
      if (
        !$(e.target).is(".filter-sort *") &&
        !$(e.target).is(".filter__group *")
      ) {
        $(".filter-sort__list").removeClass("filter-sort__list--active");
        $(".filter-sort-overlay").removeClass("filter-sort-overlay--active");
        $("html").removeClass("no-scroll");
      }
    });
  }
  // previousScroll = 0;
  // headerOrgOffset = 0;
  // if ($(window).width() > 1365) {
  //   if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
  // } else {
  //   if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
  // }
}
// Filters All
$(document).ready(function () {
  loadswatches();
  _initFilter();

  $(document).click(function (e) {
    if (!$(e.target).is(".filter__group *")) {
      $(".filter__list").removeClass("filter__list--active");
      $(".filter__title").removeClass("filter__title--active");
      $(".filter__list").slideUp(150);
    }
  });
});

function _initFilter() {
  // Filter - Accordion
  $(".filter__title")
    .off("click")
    .on("click", function (e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.next().hasClass("filter__list--active")) {
        $this.next().removeClass("filter__list--active");
        $this.next().slideUp(150);
      } else {
        $this
          .parent()
          .parent()
          .find(".filter__group .filter__list")
          .removeClass("filter__list--active");
        $this
          .parent()
          .parent()
          .find(".filter__group .filter__list")
          .slideUp(150);
        $this.next().toggleClass("filter__list--active");
        $this.next().slideToggle(150);
      }

      if ($this.hasClass("filter__title--active")) {
        $this.removeClass("filter__title--active");
      } else {
        $this
          .parent()
          .find(".filter__group .filter__title")
          .removeClass("filter__title--active");
        $this.toggleClass("filter__title--active");
      }
    });
}
// Canvas Cart
var dataOffcanvas;
$(document).ready(function () {
  $(function () {
    $(document).on("beforecreate.offcanvas", function (e) {
      dataOffcanvas = $(e.target).data("offcanvas-component");
    });

    $(document).on("create.offcanvas", function (e) {
      var dataOffcanvas = $(e.target).data("offcanvas-component");
    });

    $(document).on("clicked.offcanvas-trigger clicked.offcanvas", function (e) {
      var dataBtnText = $(e.target).text();
    });

    $(document).on("open.offcanvas", function (e) {
      var dataOffcanvasID = $(e.target).attr("id");
    });

    $(document).on("resizing.offcanvas", function (e) {
      var dataOffcanvasID = $(e.target).attr("id");
    });

    $(document).on("close.offcanvas", function (e) {
      var dataOffcanvasID = $(e.target).attr("id");
    });

    $(document).on("destroy.offcanvas", function (e) {
      var dataOffcanvasID = $(e.target).attr("id");
    });

    $("#bottom").on("create.offcanvas", function (e) {
      var api = $(this).data("offcanvas-component");

      $(".js-destroy").on("click", function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    });

    $("#left").offcanvas({
      modifiers: "left,overlay",
      triggerButton: ".js-offcanvas-trigger-left",
    });

    $(".js-enhance").on("click", function () {
      $(document).trigger("enhance");
    });

    $(document).trigger("enhance");
  });
});

// Filter Switch
function setCookie(cname, cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toGMTString();
  if (typeof cvalue != "string") var cvalue_string = JSON.stringify(cvalue);
  else var cvalue_string = cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
}

var layouts = {
  desktop: [4, 3],
  tablet: [3, 2],
  mobile: [2, 1],
};

function getWindowLayout() {
  var _windowWidth = jQuery(window).width();
  if (_windowWidth < 767) {
    return layouts.mobile;
  } else if (_windowWidth < 1024) {
    return layouts.tablet;
  } else {
    return layouts.desktop;
  }
}

function switchLayout(isFirst, isNext) {
  var perRow = 1;
  if (isFirst === true) {
    var _perCookie = getCookie("perrow");
    if (_perCookie != undefined) perRow = parseInt(_perCookie);
  }
  var currentPerRow = $(".filter-switch__grid")
    .get(0)
    .className.match(/show(\d)/);
  if (currentPerRow != null) {
    perRow = parseInt(currentPerRow[1]);
  }
  var _currentLayout = getWindowLayout();

  if ($.inArray(perRow, _currentLayout) == -1) {
    perRow = _currentLayout[0];
  }

  if (isNext === true) {
    perRow =
      _currentLayout[
        ($.inArray(perRow, _currentLayout) + 1) % _currentLayout.length
      ];
    setCookie("perrow", perRow);
  }

  if (currentPerRow != null) {
    $(".filter-switch__grid").removeClass(
      "filter-switch__grid--show" + currentPerRow[1]
    );
    //$('.collection .col').removeClass("show"+currentPerRow[1]);
  }
  $(".filter-switch__grid").addClass("filter-switch__grid--show" + perRow);

  $(".collection .col").each(function () {
    var cn = this.className.match("xs-3");
    if (cn != null) $(this).removeClass(cn[0]);
    var cn = this.className.match("xs-4");
    if (cn != null) $(this).removeClass(cn[0]);
    var cn = this.className.match("xs-6");
    if (cn != null) $(this).removeClass(cn[0]);
    var cn = this.className.match("xs-12");
    if (cn != null) $(this).removeClass(cn[0]);
    var _classname = "xs-3";
    switch (perRow) {
      case 1:
        _classname = "xs-12";
        break;
      case 2:
        _classname = "xs-6";
        break;
      case 3:
        _classname = "xs-4";
        break;
    }
    $(this).addClass(_classname);
  });
}

function layoutSwitch(isFirst) {
  if ($(".filter-switch").length > 0) {
    switchLayout(isFirst);

    $(".filter-switch").off("click");
    $(".filter-switch").on("click", function () {
      switchLayout(false, true);
    });
  }
}
$(document).ready(function () {
  $(window).on("load resize", function () {
    layoutSwitch(true);
  });
});

// $(window).scroll(function() {
//   var scroll = $(window).scrollTop();
//   if (scroll >= 100) {
//     $(".header").addClass("header--sticky").removeClass("header--hover");
//   } else {
//     $(".header:not('.header--hover')").removeClass("header--sticky").removeClass("header--hover");
//   }
// });

// Header Sticky
var previousScroll = 0;
var headerOrgOffset = 200;
//if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

// $(window).scroll(function () {

//   if ($('.header').length>0) {
//     var currentScroll = $(this).scrollTop();
//     // if (currentScroll > headerOrgOffset) {
//     //   if (currentScroll > previousScroll) {
//     //     $('html:not(".no-scroll") .header').removeClass('header--sticky');
//     //     $('html:not(".no-scroll") .header').removeClass('header--hover');
//     //     $('html:not(".no-scroll") .header').addClass('header--hidden');
//     //   } else {
//     //     $('html:not(".no-scroll") .header').addClass('header--sticky');
//     //     $('html:not(".no-scroll") .header').removeClass('header--hidden');
//     //   }
//     // } else {
//     //   $('html:not(".no-scroll") .header').removeClass('header--sticky');
//     // }
//     // previousScroll = currentScroll;

//     if (currentScroll > previousScroll) {
//       if (currentScroll > headerOrgOffset) {
//         $('html:not(".no-scroll") .header--sticky').addClass('header--hidden');
//         $('html:not(".no-scroll") .header').removeClass('header--sticky');
//         $('html:not(".no-scroll") .header').removeClass('header--hover');
//       }
//     } else {
//       $('html:not(".no-scroll") .header').addClass('header--sticky');
//       $('html:not(".no-scroll") .header').removeClass('header--hidden');
//     }
//     if (currentScroll == 0) {
//       $('html:not(".no-scroll") .header').removeClass('header--sticky');
//     }
//     previousScroll = currentScroll;

//   }
// });

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
    headerOrgOffsetFilter = $(".filters").offset().top + -62;

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass(
          "filters__container--sticky"
        );
      } else {
        $('html:not(".no-scroll") .filters__container').addClass(
          "filters__container--sticky"
        );
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass(
        "filters__container--sticky"
      );
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Product Page - Sticky Button
$(document).on("scroll", function () {
  if ($(window).scrollTop() > 50) {
    $(".product-add-mobile").addClass("product-add-mobile--sticky");
  } else {
    $(".product-add-mobile").removeClass("product-add-mobile--sticky");
  }
});

// Header Search Toggle
$(document).ready(function () {
  $(".header-search__toggle").click(function () {
    $(".header-search__form").toggleClass("header-search__form--visible");
    $(".header").toggleClass("header--search");
    $(".site-container").toggleClass("site-container--blackout");
    $(".header-search__input").focus();
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $(".site-container").removeClass("site-container--blackout");
      $(".header").removeClass("header--search");
      $(".header-search__form").removeClass("header-search__form--visible");
    }
  });
});

// function productFeaturedCarousel() {
//   var slideWrapper = $(".product-images__featured-carousel"),
//       iframes = slideWrapper.find('.product-images__embed-player'),
//       lazyImages = slideWrapper.find('.product-images__featured-item'),
//       lazyCounter = 0;

//   // POST commands to YouTube or Vimeo API
//   function postMessageToPlayer(player, command){
//     if (player == null || command == null) return;
//     player.contentWindow.postMessage(JSON.stringify(command), "*");
//   }

//   // When the slide is changing
//   function playPauseVideo(slick, control){
//     var currentSlide, slideType, startTime, player, video;

//     currentSlide = slick.find(".slick-current");
//     slideType = currentSlide.attr("class").split(" ")[1];
//     player = currentSlide.find("iframe").get(0);
//     startTime = currentSlide.data("video-start");

//     if (slideType === "vimeo") {
//       switch (control) {
//         case "play":
//           if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
//             currentSlide.addClass('started');
//             postMessageToPlayer(player, {
//               "method": "setCurrentTime",
//               "value" : startTime
//             });
//           }
//           postMessageToPlayer(player, {
//             "method": "play",
//             "value" : 1
//           });
//           break;
//         case "pause":
//           postMessageToPlayer(player, {
//             "method": "pause",
//             "value": 1
//           });
//           break;
//       }
//     } else if (slideType === "youtube") {
//       switch (control) {
//         case "play":
//           postMessageToPlayer(player, {
//             "event": "command",
//             "func": "mute"
//           });
//           postMessageToPlayer(player, {
//             "event": "command",
//             "func": "playVideo"
//           });
//           break;
//         case "pause":
//           postMessageToPlayer(player, {
//             "event": "command",
//             "func": "pauseVideo"
//           });
//           break;
//       }
//     } else if (slideType === "video") {
//       video = currentSlide.children("video").get(0);
//       if (video != null) {
//         if (control === "play"){
//           video.play();
//         } else {
//           video.pause();
//         }
//       }
//     }
//   }

//   // Resize player
//   function resizePlayer(iframes, ratio) {
//     if (!iframes[0]) return;
//     var win = $(".product-images__featured-carousel"),
//         width = win.width(),
//         playerWidth,
//         height = win.height(),
//         playerHeight,
//         ratio = ratio || 16/9;

//     iframes.each(function(){
//       var current = $(this);
//       if (width / ratio < height) {
//         playerWidth = Math.ceil(height * ratio);
//         current.width(playerWidth).height(height).css({
//           left: (width - playerWidth) / 2,
//            top: 0
//           });
//       } else {
//         playerHeight = Math.ceil(width / ratio);
//         current.width(width).height(playerHeight).css({
//           left: 0,
//           top: (height - playerHeight) / 2
//         });
//       }
//     });
//   }

//   // DOM Ready
//   $(function() {
//     // Initialize
//     slideWrapper.on("init", function(slick){
//       slick = $(slick.currentTarget);
//       setTimeout(function(){
//         playPauseVideo(slick,"play");
//       }, 1000);
//       resizePlayer(iframes, 16/9);
//     });
//     slideWrapper.on("beforeChange", function(event, slick) {
//       slick = $(slick.$slider);
//       playPauseVideo(slick,"pause");
//     });
//     slideWrapper.on("afterChange", function(event, slick) {
//       slick = $(slick.$slider);
//       playPauseVideo(slick,"play");
//     });
//     slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
//       lazyCounter++;
//       if (lazyCounter === lazyImages.length){
//         lazyImages.addClass('show');
//         // slideWrapper.slick("slickPlay");
//       }
//     });

//     //start the slider
//     slideWrapper.slick({
//       // fade:true,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       autoplaySpeed:4000,
//       lazyLoad:"progressive",
//       speed:600,
//       dots: false,
//       arrows: true,
//       infinite: false,
//       //cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
//       responsive: [
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//             arrows: true,
//           }
//         }
//       ]
//     });
//   });

//   // Resize event
//   $(window).on("resize.slickVideoPlayer", function(){
//     resizePlayer(iframes, 16/9);
//   });
// }

// function productThumbsCarousel() {
//   // Change the main image whenever a thumbnail button is activated
//   $('.product-images__thumbs-carousel').on('init', function(e, slider) {
//     $(slider.$slides.find('.product-images__thumb-link')).each(function(index) {
//       $(this).on('click', function() {
//         // Move aria-current="true" to this button
//         $(slider.$slides.find('.product-images__thumb-link').removeAttr('aria-current'));
//         $(this).attr('aria-current', true);

//         // Change the main image to match this thumbnail button
//         var index = $(this).closest('.slick-slide').data('slick-index');
//         $('.product-images__thumbs-carousel').slick('slickGoTo', index);
//       });
//     });
//   });
//   $('.product-images__thumbs-carousel:not(.slick-initialized)').slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     asNavFor: '.product-images__featured-carousel',
//     dots: false,
//     infinite: false,
//     arrows: true,
//     centerMode: false,
//     vertical: false
//   });
// }

// Collection Description Toggle
$(document).ready(function () {
  $(".collection__toggle")
    .off("click")
    .on("click", function () {
      $(".collection__description").toggleClass(
        "collection__description--visible"
      );
      $(".collection__show-hide").toggle();
      return false;
    });
});

// Footer Accordions
$(document).ready(function () {
  $(".footer-content__accordion-header")
    .off("click")
    .on("click", function () {
      $(this).toggleClass("footer-content__accordion-header--shown");
      $(this).next(".footer-content__accordion-content").slideToggle(200);
      return false;
    });
});

// Help Accordions
$(document).ready(function () {
  $(".help__sidebar-header")
    .off("click")
    .on("click", function () {
      $(this).toggleClass("help__sidebar-header--shown");
      $(this).next(".help__sidebar-links").slideToggle(200);
      return false;
    });
});

// Cookie Notice
function _showCookieBar() {
  if (Shopify.designMode !== true) {
    $(".cookie-notice").cookieBar({
      closeButton: ".cookie-notice__button",
    });
  }
}

// Currency Converter
$(document).ready(function () {
  $(".shopify-currency-form select").on("change", function () {
    $(this).parents("form").submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css("display", "flex").hide();
$(".nav__single .nav__sub-menu").css("display", "block").hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1549) {
    $(".nav-overlay").stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    $(this)
      .children(".nav__link")
      .children("span")
      .stop(!0, !0)
      .delay(250)
      .fadeIn();
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1549) {
    $(".nav-overlay").stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    $(this)
      .children(".nav__link")
      .children("span")
      .stop(!0, !0)
      .delay(250)
      .fadeOut();
  }
});
$(".header").on("mouseenter", function (e) {
  if (window.innerWidth > 1549) {
    $(this).children(".header__hover").show();
    $(".header").addClass("header--hover");
  }
});

// Finance Popup - Klarna
$(".product-finance__link--klarna-30").on("click", function () {
  $(".product-finance-popup--klarna-30").addClass(
    "product-finance-popup--active"
  );
  $("html").addClass("noscroll-finance-popup");
});
$(".product-finance__link--klarna").on("click", function () {
  $(".product-finance-popup--klarna").addClass("product-finance-popup--active");
  $("html").addClass("noscroll-finance-popup");
});

// Finance Popup - Clearpay
$(".product-finance__link--clearpay").on("click", function () {
  $(".product-finance-popup--clearpay").addClass(
    "product-finance-popup--active"
  );
  $("html").addClass("noscroll-finance-popup");
});

// Finance Popup - Laybuy
$(".product-finance__link--laybuy").on("click", function () {
  $(".product-finance-popup--laybuy").addClass("product-finance-popup--active");
  $("html").addClass("noscroll-finance-popup");
});

// Finance Popup - Zip
$(".product-finance__link--zip").on("click", function () {
  $(".product-finance-popup--zip").addClass("product-finance-popup--active");
  $("html").addClass("noscroll-finance-popup");
});

// Finance Popup - Close
$(".product-finance-popup__close").on("click", function () {
  $(".product-finance-popup").removeClass("product-finance-popup--active");
  $("html").removeClass("noscroll-finance-popup");
});

$(document).mouseup(function (e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".product-finance-popup--active").removeClass(
      "product-finance-popup--active"
    );
    $("html").removeClass("noscroll-finance-popup");
  }
});

// Account Tabs
$(".account .tab").on("click", function () {
  var tab_id = $(this).attr("data-tab");
  $(".account__tab").removeClass("account__tab--active");
  $(".account__content").hide();
  $(this).addClass("account__tab--active");
  $("#" + tab_id).show();
});

// Mobile Nav
$(document).ready(function () {
  // Clone
  $(".nav__sub-menu").each(function () {
    $(this)
      .clone()
      .addClass("nav__sub-menu--cloned")
      .insertAfter(".header-nav")
      .wrapInner("<div class='nav__sub-menu__wrap'></div>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $(".header-mobile")
    .off("click")
    .on("click", function () {
      $(this).toggleClass("header-mobile--active");
      $(".header-nav").toggle();
      $(".header-nav").toggleClass("header-nav--active");
      $("html").toggleClass("no-scroll-mobile-nav");
      $(".mobile-nav-overlay").toggle();
      $(".nav__sub-menu--cloned").removeClass("nav__sub-menu--active");
      $(".nav").removeClass("nav--hidden");
    });

  // Close Nav (Mobile) - Click Function
  $(".mobile-nav-overlay")
    .off("click")
    .on("click", function () {
      $(".header-mobile").removeClass("header-mobile--active");
      $(".header-nav").hide();
      $(".header-nav").removeClass("header-nav--active");
      $("html").removeClass("no-scroll-mobile-nav");
      $(".mobile-nav-overlay").hide();
      $(".nav").removeClass("nav--hidden");
      $(".nav__sub-menu--cloned").removeClass("nav__sub-menu--active");
    });

  // Open Sub Menu - Click Function
  $(".nav__dropdown .nav__link")
    .off("click")
    .on("click", function (event) {
      if ($(window).width() < 1549) {
        event.preventDefault();
      }
      var id = $(this).attr("id");
      $(".nav__sub-menu").each(function () {
        var dataid = $(this).attr("data-id");
        console.log(dataid);
        if (id == dataid) {
          $(this).addClass("nav__sub-menu--active");
        }
      });
      $(".nav").addClass("nav--hidden");
    });

  // Back Button - Click Function
  $(".nav__sub-menu__back")
    .off("click")
    .on("click", function () {
      $(".nav__sub-menu").removeClass("nav__sub-menu--active");
      $(".nav").removeClass("nav--hidden");
    });
});

// Accordion
function productAccordion() {
  var $tabs = $(".product-accordion");
  if ($tabs.length > 0) {
    $tabs.responsiveTabs({
      rotate: false,
      startCollapsed: false,
      collapsible: "accordion",
      animation: "slide",
      duration: 300,
      setHash: false,
      disabled: [],
      classes: {
        stateDefault: "",
        stateActive: "active",
        stateDisabled: "",
        stateExcluded: "",
        container: "",
        ul: "product-accordion__nav",
        tab: "",
        anchor: "product-accordion__anchor",
        panel: "product-accordion__panel",
        accordionTitle: "product-accordion__title",
      },
    });
  }
}

// Accordion
function faqsAccordion() {
  var $faqstabs = $(".faqs-accordion");
  if ($faqstabs.length > 0) {
    $faqstabs.responsiveTabs({
      rotate: false,
      startCollapsed: true,
      collapsible: "accordion",
      animation: "slide",
      duration: 300,
      setHash: false,
      disabled: [],
      classes: {
        stateDefault: "",
        stateActive: "active",
        stateDisabled: "",
        stateExcluded: "",
        container: "",
        ul: "faqs-accordion__nav",
        tab: "",
        anchor: "faqs-accordion__anchor",
        panel: "faqs-accordion__panel",
        accordionTitle: "faqs-accordion__title",
      },
    });
  }
}

// RESPONSIVE TABS
function _faqsAccordion() {
  if (window.tabs1) {
    window.tabs1.forEach((x) => {
      $(x).responsiveTabs({
        rotate: false,
        startCollapsed: true,
        collapsible: "accordion",
        animation: "slide",
        duration: 300,
        setHash: false,
        disabled: [],
        classes: {
          stateDefault: "",
          stateActive: "active",
          stateDisabled: "",
          stateExcluded: "",
          container: "",
          ul: "faqs-accordion__nav",
          tab: "",
          anchor: "faqs-accordion__anchor",
          panel: "faqs-accordion__panel",
          accordionTitle: "faqs-accordion__title",
        },
      });
    });
  }
}

// Swatches
function initSwatches() {
  if (window.swatches != undefined && document.location) {
    $(".swatches__col").off("mouseenter mouseleave");
    $(".swatches__col").off("click");

    if ($(window).width() > 599) {
      $(".swatches__col").hover(
        function () {
          if ($(this).closest("[data-group-col]").length > 0) {
            let _id = $(this).data("product-id");
            let _h = window.swatches.filter(function (e) {
              return e.id == _id;
            });
            if (_h.length > 0) {
              showSwatchData(this, _h[0]);
            } else {
              //swatch data not exist - need get firstly
              let el = this;
              var _handle;
              if (productsForFilter.length == 0) {
                _handle = $(this).attr("href").replace("/products/", "");
              } else {
                _handle = productsForFilter.filter(
                  (item) =>
                    item.id === window.btoa("gid://shopify/Product/" + _id)
                )[0].handle;
              }
              if (_handle != undefined) {
                getSwatchData(_handle, function (h) {
                  showSwatchData(el, this);
                });
              }
            }
          }
        },
        function () {
          if ($(this).closest("[data-group-col]").length > 0) {
            let _id = $(this)
              .parent()
              .find("[class*='--current']")
              .closest("a")
              .data("product-id");
            let _h = window.swatches.filter(function (e) {
              return e.id == _id;
            });
            if (_h.length > 0) {
              showSwatchData(this, _h[0]);
            } else {
              //swatch data not exist - need get firstly
              let el = this;
              var _handle;
              if (productsForFilter.length == 0) {
                _handle = $(this).attr("href").replace("/products/", "");
              } else {
                _handle = productsForFilter.filter(
                  (item) =>
                    item.id === window.btoa("gid://shopify/Product/" + _id)
                )[0].handle;
              }
              if (_handle != undefined) {
                getSwatchData(_handle, function (h) {
                  showSwatchData(el, this);
                });
              }
            }
          }
        }
      );
    } else {
      $(".swatches__col").on("click", function (e) {
        if ($(this).closest("[data-group-col]").length > 0) {
          if ($("div", this).hasClass("swatches__swatch--current")) return true;
          e.preventDefault();
          $(this)
            .closest(".swatches")
            .find(".swatches__swatch--current")
            .removeClass("swatches__swatch--current");
          $("div", this).addClass("swatches__swatch--current");
          const _id = $(this).data("product-id");
          const _h = window.swatches.filter(function (e) {
            return e.id == _id;
          });
          if (_h.length > 0) {
            showSwatchData(this, _h[0]);
          } else {
            //swatch data not exist - need get firstly
            const el = this;
            var _handle;
            if (productsForFilter.length == 0) {
              _handle = $(this).attr("href").replace("/products/", "");
            } else {
              _handle = productsForFilter.filter(
                (item) =>
                  item.id === window.btoa("gid://shopify/Product/" + _id)
              )[0].handle;
            }
            if (_handle != undefined) {
              getSwatchData(_handle, function (h) {
                showSwatchData(el, this);
              });
            }
          }
          return false;
        }
      });
    }
  }
}

function getSwatchData(_handle, callback) {
  $.ajax({
    method: "GET",
    url: document.location.origin + "/products/" + _handle + "/?view=swatch",
    success: function (data) {
      var _d = data.replace(/\n/g, "").replace(/,}/g, "}");
      window.swatches = window.swatches || [];
      const h = JSON.parse(_d);
      window.swatches.push(h);
      callback.apply(h);
    },
  });
}
function showSwatchData(el, h) {
  var item = $(el).closest(".product-card");
  item.find(".product-card__image").attr("src", h.image);
  item.find("a:not(.swatches__col)").attr("href", h.url);
  item.find(".product-card__image").attr("srcset", "");
  item.find(".product-card__title").text(h.title);
  item.find(".product-card__sku span").text(h.sku);
  item.find(".product-card__price-current").html(h.price);
  item.find(".product-card__price").removeClass("product-card__price--on-sale");
  item.find(".product-card__price").addClass(h.onsale);
  item.find(".product-card__price-compare").html(h.pricecompare);
  item.find(".product-card__price-saving").html(h.saving);
  item.find(".product-card__overlays").replaceWith(h.overlays);
}

// Run Functions
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach((x) => {
    if (x.evt && !$(x.el).is(document)) {
      if (x.evt == arguments[0].type && $(x.el).is(arguments[0].target)) {
        $(x.el).off(x.evt + "." + x.f);
        if (typeof x.f == "function") {
          setTimeout(x.f, 0);
        } else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(
          window.afterLoadWithEvents.indexOf(x),
          1
        );
      }
    } else {
      if (typeof x.f == "function") {
        setTimeout(x.f, 0);
      } else {
        window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(
        window.afterLoadWithEvents.indexOf(x),
        1
      );
    }
  });
  if (window.afterLoadWithEvents.length == 0) {
    $(window).off("scroll.afterLoad");
  }
}
function loadswatches(ismissed) {
  if (ismissed !== true) {
    //product detail group swatch
    $("[data-group]").each(function () {
      let el = $(this);
      let tags = [];
      tags.push("Product Group Code|" + el.data("group"));

      renderSwatchAndOverlay(tags, function () {
        let overlayHtml = "";
        let htmlItems = [];
        let _tag = el.data("group");

        _productsData
          .filter((p) => p.GroupCode == _tag)
          .forEach((p) => {
            let current = "";
            overlayHtml = p.overlay;
            htmlItems.push(
              _swatchSettings.item
                .replace("{{id}}", p.id)
                .replace("{{url}}", p.handle)
                .replace("{{color}}", p.swatchColor)
                .replaceAll("{{name}}", p.swatchName)
                .replace("{{current}}", current)
            );
          });
        el.empty().append(htmlItems.join(""));
        $("[data-group]")
          .find('[href="' + document.location.pathname + '"] .swatches__swatch')
          .addClass("swatches__swatch--current");
      });
    });
  }
  let sEl = $("[data-group-col]");
  if (ismissed !== true) {
    sEl = $("[data-group-col]:not(:has(.swatches__col))");
  }
  if (sEl.length > 0) {
    let tags = [];
    sEl.each(function () {
      const t = "Product Group Code|" + $(this).data("group-col");
      if (!tags.includes(t)) tags.push(t);
    });
    renderSwatchAndOverlay(tags, function () {
      sEl.each(function () {
        let overlayHtml = "";
        let htmlItems = [];
        let _tag = $(this).data("group-col");
        let _productsForTag = _productsForTags.filter((p) => p.tag == _tag);
        let _id = $(this).data("group-col-id");
        if (_productsForTag.length == 0) {
          _productsForTags.push({
            tag: _tag,
            products: _productsData.filter((p) => p.GroupCode == _tag),
          });
          _productsForTag = _productsForTags.filter((p) => p.tag == _tag);
        }
        if (_productsForTag.length > 0) {
          _productsForTag[0].products.forEach((p) => {
            let current = "";
            if (_id == p.id) {
              current = "swatches__swatch--current";
              overlayHtml = p.overlay;
            }
            htmlItems.push(
              _swatchSettings.item
                .replace("{{id}}", p.id)
                .replace("{{url}}", p.handle)
                .replace("{{color}}", p.swatchColor)
                .replaceAll("{{name}}", p.swatchName)
                .replace("{{current}}", current)
            );
          });
          $(this).empty().append(htmlItems.join(""));
          //$(this).closest('.product-card').find('.product-card__image-link .product-card__overlays').remove();
          //$(this).closest('.product-card').find('.product-card__image-link').append(overlayHtml);
        }
      });
      window.swatches = [];
      initSwatches();
    });
  }
}
function register() {
  jQuery("html").removeClass("no-js").addClass("js");
  if (window.ReadyScript) {
    window.ReadyScript.forEach((x) => {
      loadScript(x.s, x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach((x) => {
      if (x.p != undefined) {
        window[x.f].apply(x.p);
      } else {
        window[x.f].apply();
      }
    });
  }

  if (window.afterLoadWithEvents) {
    $(window).on("scroll.afterLoad", _checkafterLoadEvents);
    window.afterLoadWithEvents.forEach((x) => {
      if (x.evt) {
        $(x.el).on(x.evt + "." + x.f, _checkafterLoadEvents);
      }
    });
  }
  productAccordion();
  faqsAccordion();
}

// window.afterLoadWithEvents = window.afterLoadWithEvents || [];
//   window.afterLoadWithEvents.push(
//   {
//       f:"_register",
//       evt: 'mousemove',
//       el: document
//   });
// function _register() {
//   checkUserLocation();
// };
$(document).ready(function () {
  register();
  if ($("[data-cart-qty]").length > 0) {
    $("[data-cart-qty]").on("focusout", function () {
      if (parseInt($(this).data("cart-qty")) != parseInt($(this).val())) {
        $(this).closest("form").get(0).submit();
      }
    });
  }
  // MIXITUP
  if (document.querySelector(".mix-container")) {
    var containerEl = document.querySelector(".mix-container");
    var mixer = mixitup(containerEl, {
      classNames: {
        block: "blog__filter",
        elementFilter: "",
      },
    });
  }
});

// load scripts after page load
function loadScript(sc, callback) {
  if ($.isArray(sc)) {
    let lc = document.createElement("script");
    lc.type = "text/javascript";
    lc.src = sc[0];
    sc.splice(0, 1);
    if (sc.length > 0) {
      $(lc).on("load", function () {
        loadScript(sc, callback);
      });
    } else if (callback != undefined) {
      $(lc).on("load", function () {
        window[callback].apply();
      });
    }
    document.getElementsByTagName("body")[0].appendChild(lc);
  } else {
    let lc = document.createElement("script");
    lc.type = "text/javascript";
    lc.src = sc;
    if (callback != undefined) {
      $(lc).on("load", function () {
        window[callback].apply();
      });
    }
    document.getElementsByTagName("body")[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function (event) {
  register();
});

var productDetailImagesSwiper;
var _productsData = [];
var _productsForTags = [];
var _swatchSettings = {
  template: '<div class="swatches product-card__swatches">{{items}}</div>',
  item: `<a class="swatches__col" data-product-id="{{id}}" href="{{routes.root_url}}/products/{{url}}" title="{{name}}">
	<div class="swatches__swatch {{current}}">
	  <span style="background-color: {{color}}"></span>
	</div>
	<div class="swatches__tag">{{name}}</div>
	</a>`,
  overlay:
    '<div class="product-card__overlays"><div class="product-card__overlay product-card__overlay--{{overlay}}">{{message}}</div></div>',
};
function renderSwatchAndOverlay(tags, callback) {
  if (tags.length > 0) {
    var tagsVar = "tag:'" + tags.join("' OR '") + "'";
    FetchDataWithVariables(
      `query($tagsVar: String){
      			products( first: 250,query:$tagsVar) {
            	edges{
          			node {
			            id
			            handle
						title
						tags
						images(first:2) {    
							edges {       
								node {
									originalSrc     
									id
								}
							}
						}						
						variants(first: 100) {
      						edges {
        						node {       
									price { amount }
									compareAtPrice { amount }
									availableForSale
									id	  							
        						}
      						}
    					}
        			}
      			}  
    			}  			
		}`,
      { tagsVar },
      function (data) {
        //console.log(data);

        let Products = data.data.products.edges;
        for (let p of Products) {
          if (_productsData.filter((c) => c.id == p.node.id).length == 0) {
            let _product = {
              id: p.node.id.replace("gid://shopify/Product/", ""),
              handle: p.node.handle,
              title: p.node.title,
            };
            _product.overlays = [];

            p.node.tags.forEach((t) => {
              if (t.startsWith("Product Group Code|"))
                _product.GroupCode = t.replace("Product Group Code|", "");
              if (t.startsWith("Swatch Name|"))
                _product.swatchName = t.replace("Swatch Name|", "");
              if (t.startsWith("Swatch Colour|"))
                _product.swatchColor = t.replace("Swatch Colour|", "");
            });

            _product.images_info = [];
            for (let v of p.node.images.edges) {
              _product.images_info.push({
                id: v.node.id,
                src: v.node.originalSrc,
                width: 1000,
                height: 1500,
              });
            }
            _product.variants = [];
            let allowSale = false;
            for (let v of p.node.variants.edges) {
              if (v.node.availableForSale === true) allowSale = true;
              _product.variants.push({
                id: v.node.id,
                price: v.node.price.amount,
                available: v.node.availableForSale,
                compare_at_price:
                  v.node.compareAtPrice != null
                    ? v.node.compareAtPrice.amount
                    : null,
              });
            }
            let minPriceVariant = _product.variants.sort(
              (a, b) => a.price - b.price
            )[0];
            _product.compare_at_price_min = parseFloat(
              minPriceVariant.compare_at_price
            );
            _product.price_min = parseFloat(minPriceVariant.price);
            let _overlayHtml = _swatchSettings.overlay;
            let overlayItems = [];
            _product.overlays.forEach((o) => {
              switch (o.key) {
                case "top_left_overlay":
                  _overlayHtml = _overlayHtml.replace(
                    "{{overlay}}",
                    "top-left"
                  );
                  break;
                case "top_right_overlay":
                  _overlayHtml = _overlayHtml.replace(
                    "{{overlay}}",
                    "top-right"
                  );
                  break;
                case "bottom_overlay":
                  _overlayHtml = _overlayHtml.replace("{{overlay}}", "bottom");
                  break;
                default:
                  _overlayHtml = _overlayHtml.replace("{{overlay}}", "");
                  break;
              }
              overlayItems.push(_overlayHtml.replace("{{message}}", o.value));
            });
            _product.overlay = overlayItems.join("");
            if (allowSale) {
              _productsData.push(_product);
            }
          }
        }
        //console.log(_productsData);

        callback.apply();
      }
    );
  }
}

document.addEventListener("lazybeforeunveil", function (e) {
  var bg = e.target.getAttribute("data-bg");
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

// Product Page LightGallery Popup
if ($("#lightgallery").length != 0) {
  lightGallery(document.getElementById("lightgallery"), {
    selector: ".product-images__featured-item",
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: "C1DB9144-799D4957-B3C1226F-C451F4A3",
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
    },
  });
}

// Gallery Page LightGallery Popup
if ($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById("lightgallerypage"), {
    selector: ".gallery__image-link",
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: "C1DB9144-799D4957-B3C1226F-C451F4A3",
    mobileSettings: {
      controls: true,
      showCloseIcon: true,
      download: false,
    },
  });
}

// Recharge App
// $(window).on('load', function() {
//   $(".onetime-radio .rc-radio__label").html($(".onetime-radio .rc-radio__label").html().replace("£", "<span class='rc-radio__price'>£</span>"));
// });

// Swatch product colour
$(window).on("load", function () {
  let colour_org = $(".product-swatches__label").text();
  $(".swatches__col").hover(
    function () {
      var colour_new = $(this).children(".swatches__tag").text();
      $(".product-swatches__label").text(colour_new);
    },
    function () {
      $(".product-swatches__label").text(colour_org);
    }
  );
});

// Swatch product colour - Variants
let v_colour_org = $(".variant__header--colour").text();

$(".variant__header--colour ~ .variant__element")
  .off("click")
  .on("click", function () {
    v_colour_org = $(this).children(".variant__tooltip").text();
    $(".variant__header--colour").text(v_colour_org);
  });

$(".variant__header--colour ~ .variant__element").hover(
  function () {
    var v_colour_new = $(this).children(".variant__tooltip").text();
    $(".variant__header--colour").text(v_colour_new);
  },
  function () {
    $(".variant__header--colour").text(v_colour_org);
  }
);

// Product Tabs
$(".product-tabs__tab")
  .off("click")
  .on("click", function () {
    var t = $(this).data("tab");

    if ($(this).hasClass("inactive")) {
      //this is the start of our condition
      $(".product-tabs__tab").addClass("inactive");
      $(".product-tabs__tab").each(function () {
        if ($(this).data("tab") == t) {
          $(this).removeClass("inactive");
        }
      });

      $(".product-tabs__content").hide();
      $("#" + t).show();
    }
  });

// Product Tabs - Accordion
$(".product-tabs__accordion-header").on("click", function () {
  if ($(this).hasClass("active")) {
    $(".product-tabs__accordion-header").removeClass("active");
    $(".product-tabs__accordion-content").slideUp();
  } else {
    $(".product-tabs__accordion-content").slideUp();
    $(".product-tabs__accordion-header").removeClass("active");
    $(this).addClass("active");
    $(this)
      .children(".product-tabs__accordion-icon")
      .toggleClass("product-tabs__accordion-icon--active");
    $(this).next().slideToggle();
  }
});

//Smooth Scroll
jQuery(document).ready(function ($) {
  $(".help-faqs-nav__link").click(function (e) {
    e.preventDefault();
    var targetElement = $(this).attr("href");
    var targetPosition = $(targetElement).offset().top;
    $("html, body").animate({ scrollTop: targetPosition - 0 }, "slow");
  });
});

//Cart Qty & Canvas Cart
jQuery(document).ready(function ($) {
  $(".cart-item__quantity-plus,.cart-prod-quantity__plus")
    .off("click")
    .on("click", function () {
      var input = $(this).prev();
      var value = $(input).val();
      $(input).val(parseInt(value) + 1);
    });
  $(".cart-item__quantity-minus,.cart-prod-quantity__minus")
    .off("click")
    .on("click", function () {
      var input = $(this).next();
      var value = $(input).val();
      if (value > 0) {
        $(input).val(parseInt(value) - 1);
      }
    });
});

//  Tabs
jQuery(document).ready(function ($) {
  $(".js-tab")
    .off("click")
    .on("click", function () {
      var t = $(this).data("tab");

      if ($(this).hasClass("inactive")) {
        //this is the start of our condition
        $(".js-tab").addClass("inactive");
        $(".js-tab").each(function () {
          if ($(this).data("tab") == t) {
            $(this).removeClass("inactive");
          }
        });

        $(".product-modes__message").hide();
        $("#" + t).show();
      }
    });
});

// Delayed Video (On mousemove)
var videoPlayer = document.getElementById("vbanner");
if (videoPlayer) {
  window.afterLoadWithEvents.push({
    f: "_loadVideo",
    evt: "mousemove",
    el: document,
  });
  function _loadVideo() {
    // Video
    var valSources = document.querySelectorAll("video#vbanner source"),
      valVideo = document.querySelector("video#vbanner"),
      valDataSrc = "data-src",
      valDataPoster = "data-poster";

    if (window.innerWidth < 601) {
      valDataSrc = "data-src-mobile";
      valDataPoster = "data-poster-mobile";
    }

    for (var i = 0; i < valSources.length; i++) {
      valSources[i].setAttribute(
        "src",
        valSources[i].getAttribute(valDataSrc) || ""
      );
    }

    valVideo.load();

    videoPlayer.addEventListener("canplaythrough", function () {
      videoPlayer.play();
    });
  }
}

// AutoPlay Video
var videoAuto = document.getElementById("vbannerauto");
if (videoAuto) {
  // Video
  var valSources = document.querySelectorAll("video#vbannerauto source"),
    valVideo = document.querySelector("video#vbannerauto"),
    valDataSrc = "data-src",
    valDataPoster = "data-poster";

  if (window.innerWidth < 601) {
    valDataSrc = "data-src-mobile";
    valDataPoster = "data-poster-mobile";
  }

  for (var i = 0; i < valSources.length; i++) {
    valSources[i].setAttribute(
      "src",
      valSources[i].getAttribute(valDataSrc) || ""
    );
  }

  valVideo.load();

  videoAuto.addEventListener("canplaythrough", function () {
    videoAuto.play();
  });
}

// Swiper Slider - Default
if ($(".swiper--default").length > 0) {
  let swiperInstances = [];
  $(".swiper--default").each(function (index, obj) {
    const $this = $(this);
    $this.addClass("swiper-" + index);
    $this.find(".swiper-pagination").addClass("pagination-" + index);
    $this.find(".swiper-button-prev").addClass("prev-" + index);
    $this.find(".swiper-button-next").addClass("next-" + index);
    $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

    if ($this.find(".swiper-pagination").length) {
      $pagination = ".pagination-" + index;
    } else {
      $pagination = null;
    }

    if ($this.find(".swiper-button-next").length) {
      $next = ".next-" + index;
    } else {
      $next = null;
    }

    if ($this.find(".swiper-button-prev").length) {
      $prev = ".prev-" + index;
    } else {
      $prev = null;
    }

    if ($this.find(".swiper-scrollbar").length) {
      $scrollbar = ".scrollbar-" + index;
    } else {
      $scrollbar = null;
    }

    if ($this.find(".swiper-snap").length) {
      $freemode = false;
    } else {
      $freemode = true;
    }

    swiperInstances[index] = new Swiper(".swiper-" + index, {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      navigation: {
        prevEl: $prev,
        nextEl: $next,
      },
      pagination: {
        el: $pagination,
        clickable: true,
      },
      scrollbar: {
        el: $scrollbar,
        draggable: true,
        snapOnRelease: false,
      },
      mousewheel: {
        forceToAxis: true,
      },
      // freeMode: {
      //   enabled: $freemode,
      //   minimumVelocity: 0,
      //   momentumBounce: false,
      //   momentumRatio: 0.5,
      //   momentumVelocityRatio: 1.5,
      // }
    });
  });
  setTimeout(function () {
    for (const slider of swiperInstances) {
      slider.update();
      var id = $(slider.el).attr("id");
      if ($(".home-variants").length > 0) {
        if (id == "home-variants-swiper") {
          slider.onAny(function () {
            if (window.innerWidth > 766) {
              var slide = slider.slides[slider.activeIndex + 1];
            } else {
              var slide = slider.slides[slider.activeIndex];
            }
            var colour = $(slide).data("colour");
            $(".home-variants__header").attr("id", "home-variants-" + colour);
          });
          slider.on("activeIndexChange", function () {
            if (window.innerWidth > 766) {
              var slide = slider.slides[slider.activeIndex + 1];
            } else {
              var slide = slider.slides[slider.activeIndex];
            }
            var colour = $(slide).data("colour");
            $(".home-variants__header").attr("id", "home-variants-" + colour);
          });
        }
      }
    }
  }, 50);
}

// Product Image - Height
// jQuery(document).ready(function( $ ) {
//   if ($('.product-images').length > 0) {
//     $productHeight = $('.product-images').outerHeight();
//     $('.product-images').css('maxHeight', $productHeight + 'px');
//   }
// });

// Ticker Box
if ($(".ticker").length > 0) {
  $(".home-ticker__wrapper,.product-ticker__wrapper").each(function (index) {
    var e = $(this).children();
    for (var i = 0; i < 50; i++) {
      e.clone().appendTo(this);
    }
    const ticker = new Swiper(".ticker", {
      spaceBetween: 0,
      speed: 6000,
      autoplay: {
        delay: 1,
      },
      loop: true,
      slidesPerView: "auto",
      allowTouchMove: false,
    });
  });
}
if ($(".swiper--product-images").length > 0) {
  const productThumbsSwiper = new Swiper(".swiper--product-thumbs", {
    spaceBetween: 10,
    slidesPerView: "auto",
    direction: "horizontal",
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next--product-thumbs",
      prevEl: ".swiper-button-prev--product-thumbs",
    },
    breakpoints: {
      1280: {
        slidesPerView: 4,
        spaceBetween: 25,
        direction: "vertical",
      },
    },
  });
  productDetailImagesSwiper = new Swiper(".swiper--product-images", {
    navigation: {
      nextEl: ".swiper-button-next--product-images",
      prevEl: ".swiper-button-prev--product-images",
    },
    thumbs: {
      swiper: productThumbsSwiper,
    },
  });
}
if ($(".swiper--benefits").length > 0) {
  const productImagesSwiper = new Swiper(".swiper--benefits", {
    slidesPerGroup: 3,
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: ".swiper-pagination--benefits",
      clickable: true,
    },
  });
}
if ($(".swiper--retailers-mobile").length > 0) {
  const productImagesSwiper = new Swiper(".swiper--retailers-mobile", {
    slidesPerGroup: 2,
    slidesPerView: "auto",
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: ".swiper-pagination--retailers-mobile",
      clickable: true,
    },
  });
}
if ($(".swiper--retailers").length > 0) {
  const productImagesSwiper = new Swiper(".swiper--retailers", {
    slidesPerGroup: 2,
    slidesPerView: "auto",
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: ".swiper-pagination--retailers",
      clickable: true,
    },
    breakpoints: {
      600: {
        centerInsufficientSlides: true,
        slidesPerGroup: 3,
        slidesPerView: "auto",
        grid: {
          rows: 1,
        },
      },
      768: {
        slidesPerGroup: 4,
      },
      1024: {
        slidesPerGroup: 5,
      },
      1280: {
        slidesPerGroup: 6,
      },
    },
  });
}
jQuery(document).ready(function ($) {
  if ($(".jdgm-rev-widg__body").length > 0) {
    const reviewsSwiper = new Swiper(".jdgm-rev-widg__body", {
      //createElements: true,
      wrapperClass: "jdgm-rev-widg__reviews",
      slideClass: "jdgm-rev",
      centerInsufficientSlides: true,
      slidesPerView: 1,
      spaceBetween: 40,
      navigation: false,
      pagination: {
        el: ".jdgm-paginate",
        type: "bullets",
        clickable: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
});

//  Product - Colour Tabs
jQuery(document).ready(function ($) {
  $(".js-colour-tab")
    .off("click")
    .on("click", function () {
      var t = $(this).data("tab");
      if ($(this).hasClass("inactive")) {
        //this is the start of our condition
        $(".js-colour-tab").addClass("inactive");
        $(".js-colour-tab").each(function () {
          if ($(this).data("tab") == t) {
            $(this).removeClass("inactive");
            $colour = $(this).data("colour");
            $colour = $colour.replace(/\s+/g, "-").toLowerCase();
            $(".product-colour__header").attr(
              "id",
              "product-colour-" + $colour
            );
          }
        });
        $(".product-colour__image-row").hide();
        $(".product-colour__button").hide();
        $(".product-colour__swatch-name").hide();
        $("." + t).show();
      }
    });
});

// Sticky Text Section
$(".js-scroll-link").on("click", function () {
  var scrollAnchor = $(this).attr("data-scroll"),
    scrollPoint = $('div[data-anchor="' + scrollAnchor + '"]').offset().top - 0;
  $("body,html").animate(
    {
      scrollTop: scrollPoint,
    },
    500
  );
  return false;
});

$(document).ready(function ($) {
  $(window)
    .scroll(function () {
      var mheight = $(window).height();
      var mwindscroll = $(window).scrollTop();
      var moffset = $(".sticky-text").offset();
      if (mwindscroll >= 0) {
        $(".sticky-text__main-container").each(function (i) {
          if (window.innerWidth < 768) {
            melementtop = $(this).position().top + moffset.top - 10;
          } else {
            melementtop = $(this).position().top + moffset.top - 300;
          }
          if (melementtop <= mwindscroll) {
            $(".sticky-text__nav-header--active").removeClass(
              "sticky-text__nav-header--active"
            );
            $(".sticky-text__nav-header")
              .eq(i)
              .addClass("sticky-text__nav-header--active");
          }
        });
      } else {
        $(".sticky-text__nav-header--active").removeClass("active");
        $(".sticky-text__nav-header--active:first").addClass("active");
      }
    })
    .scroll();

  $(window)
    .scroll(function () {
      var height = $(window).height();
      var windscroll = $(window).scrollTop();
      var offset = $(".sticky-text").offset();
      if (windscroll >= 0) {
        $(".sticky-text__main-section").each(function (i) {
          elementtop = $(this).position().top + offset.top - 300;
          if (elementtop <= windscroll) {
            $(".sticky-text__nav-sub--active").removeClass(
              "sticky-text__nav-sub--active"
            );
            if ($(this).hasClass("sticky-text__main-section--1")) {
              $(".sticky-text__nav-sub--1").addClass(
                "sticky-text__nav-sub--active"
              );
            }
            if ($(this).hasClass("sticky-text__main-section--2")) {
              $(".sticky-text__nav-sub--2").addClass(
                "sticky-text__nav-sub--active"
              );
            }
            if ($(this).hasClass("sticky-text__main-section--3")) {
              $(".sticky-text__nav-sub--3").addClass(
                "sticky-text__nav-sub--active"
              );
            }
          }
        });
      } else {
        $(".sticky-text__nav-sub--active").removeClass("active");
        $(".sticky-text__nav-sub--active:first").addClass("active");
      }
    })
    .scroll();
});

// Parallax
$(window).scroll(function () {
  $(".js-parallax").each(function () {
    var offset = $(this).offset();
    var height = $(this).height();
    var posY = offset.top - window.innerHeight;
    var current = $(window).scrollTop();
    $(this).css(
      "backgroundPositionY",
      "-" + (current - posY) * (400 / (window.innerHeight + height)) + "px"
    );
  });
});

// Parallax Splash
$(window).scroll(function () {
  $(".js-parallax-splash").each(function () {
    var prate = $(this).data("prate");
    var offset = $(this).offset();
    var height = $(this).height();
    var posY = offset.top - window.innerHeight;
    var current = $(window).scrollTop();
    $(this).css(
      "backgroundPositionY",
      "-" + (current - posY) * (prate / (window.innerHeight + height)) + "px"
    );
  });
});

// Parallax Top
$(window).scroll(function () {
  $(".js-parallax-top").each(function () {
    var offset = $(this).offset();
    var height = $(this).height();
    var posY = offset.top - window.innerHeight;
    var current = $(window).scrollTop();
    $(this).css("backgroundPositionY", "-" + current * (200 / height) + "px");
  });
});

// Parallax Text
(function ($) {
  $.fn.visible = function (partial) {
    var $t = $(this),
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top + 100,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;
    return compareBottom <= viewBottom && compareTop >= viewTop;
  };
})(jQuery);

$(window).scroll(function (event) {
  $(".parallax-text figure").each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("animate");
    } else {
      //el.removeClass("animate");
    }
  });
  $(".parallax-hero__slide-2").each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("animate");
    }
  });
  $(".js-animation").each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
      el.addClass("animate");
    }
  });
});

// Delivery Page
$(document).ready(function () {
  if ($(".help-delivery").length > 0) {
    // Select 2 Output
    function formatState(state) {
      if (!state.id) {
        return state.text;
      }
      // Look for data-flag attr
      if (typeof state.element.attributes["data-flag"] != "undefined") {
        var $state = $(
          '<div class="select2-country"><img src="' +
            state.element.attributes["data-flag"].nodeValue +
            '"  /><span>' +
            state.text.trim() +
            "</span></div>"
        );
      }
      // Else display data-iso-2 attr
      else {
        var $state = $(
          '<div class="select2-country"><div class="select2-country__blank">' +
            state.element.attributes["data-iso-2"].nodeValue +
            "</div><span>" +
            state.text.trim() +
            "</span></div>"
        );
      }
      return $state;
    }
    $(".help-delivery__select").on("select2:select", function (e) {
      const countryISO3 = e.params.data.element.value;
      $(".help-delivery__option").hide();
      $(".help-delivery__option").each(function () {
        var ISO3array = $(this).data("iso-3").split(",");
        for (var i = 0; i < ISO3array.length; i++) {
          if (ISO3array[i] == countryISO3) {
            $(this).show();
          }
        }
      });
    });

    // select country based on user location
    $.ajax({
      url: "/browsing_context_suggestions.json",
      type: "get",
      error: function () {
        $(".help-delivery__select").select2({
          templateResult: formatState,
          templateSelection: formatState,
        });
        $(".help-loading").hide();
      },
      success: function (data) {
        const _value = $(
          `[data-iso-2="${data.detected_values.country.handle}"]`
        ).val();
        $(".help-delivery__select").val(_value);
        // Select 2 Init
        $(".help-delivery__select").select2({
          templateResult: formatState,
          templateSelection: formatState,
        });
        $(".help-loading").hide();
        $(".help-delivery__select").trigger({
          type: "select2:select",
          params: {
            data: {
              element: {
                value: _value,
              },
            },
          },
        });
      },
    });
  }
});

/*********************************
UPSELL POPUP
*********************************/
if ($(".upsell").length > 0) {
  // Upsell Popup - Open
  $(".upsell-button").on("click", function () {
    $(".upsell").addClass("upsell--active");
    $("html").addClass("noscroll-upsell-popup");
  });

  // Upsell Popup - Close
  $(".upsell__popup-close").on("click", function () {
    $(".upsell").removeClass("upsell--active");
    $("html").removeClass("noscroll-upsell-popup");
  });
  $(".upsell__continue").on("click", function () {
    $(".upsell").removeClass("upsell--active");
    $("html").removeClass("noscroll-upsell-popup");
  });

  // Upsell - Set Initial Selection based on Current
  var current = $(".upsell__radio-list--colour").data("subscription-current");
  $("[data-upsell-radio='colour']").each(function () {
    if ($(this).data("subscription-colour") == current) {
      $(this).addClass("active");
    }
  });
  var range = $("[data-upsell-radio='range'].active").data(
    "subscription-range"
  );
  var colour = $("[data-upsell-radio='colour'].active").data(
    "subscription-colour"
  );
  var month = $("[data-upsell-radio='month'].active").data(
    "subscription-month"
  );
  var sh_colour = "[data-upsell-colour='" + colour + "']";
  $(sh_colour).show();

  getSellPlanId();

  // Upsell - Radio Button
  $("[data-upsell-radio]").on("click", function () {
    $(this).parent().children().removeClass("active");
    $(this).addClass("active");
    $("[data-upsell-range]").hide();
    $("[data-upsell-colour]").hide();
    $("[data-upsell-month]").hide();
    var range = $("[data-upsell-radio='range'].active").data(
      "subscription-range"
    );
    var colour = $("[data-upsell-radio='colour'].active").data(
      "subscription-colour"
    );
    var colourname = $("[data-upsell-radio='colour'].active").data(
      "subscription-colour-name"
    );
    var month = $("[data-upsell-radio='month'].active").data(
      "subscription-month"
    );
    $(".upsell__radio-header span").html(colourname);

    // Show / Hide
    var sh_range = "[data-upsell-range='" + range + "']";
    var sh_colour = "[data-upsell-colour='" + colour + "']";
    var sh_month = "[data-upsell-month='" + month + "']";

    $(sh_range).show();
    $(sh_colour).show();
    $(sh_month).show();

    // Next Charge Date
    var currentday = $(".upsell__date").data("current-day");
    var currentmonth = $(".upsell__date").data("current-month");
    var currentyear = $(".upsell__date").data("current-year");
    var nextmonth = currentmonth + month;
    if (nextmonth > 12) {
      var nextmonth = nextmonth - 12;
      var currentyear = currentyear + 1;
    }
    $(".upsell__date").html(currentday + "/" + nextmonth + "/" + currentyear);

    getSellPlanId();
  });

  // Upsell - Tabs
  $(".upsell__tab").on("click", function () {
    if ($(this).hasClass("active")) {
    } else {
      $(".upsell__tab").removeClass("active");
      $(this).addClass("active");
    }
    var tab = $(this).data("upsell-tab");
    $(".upsell__tab-content").hide();
    $("#" + tab).show();
  });

  // Get selling plan id by selected options
  function getSellPlanId() {
    var range = $("[data-upsell-radio='range'].active").data(
      "subscription-range"
    );
    var colour = $("[data-upsell-radio='colour'].active").data(
      "subscription-colour"
    );
    var month = $("[data-upsell-radio='month'].active").data(
      "subscription-month"
    );
    var sp = sellPlan.filter((x) => {
      return x.product == range && x.color == colour && x.period == month;
    });
    if (sp.length == 1) {
      $("[data-upsell-add]").show();
      $("[data-upsell-add]").data("sellplan", sp[0].id);
      $("[data-upsell-add]").data("varid", sp[0].varid);
    } else {
      $("[data-upsell-add]").hide();
    }
  }

  $("[data-upsell-add]").on("click", function () {
    data = {
      id: $("[data-upsell-add]").data("varid"),
      quantity: 1,
      selling_plan: $("[data-upsell-add]").data("sellplan"),
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        window.location.href = "/cart/";
      },
    });
  });
}

// Product Sticky
$(document).ready(function () {
  $(window).on("scroll", function () {
    var productAddElement = $(".product-add");

    // Check if the element exists before trying to get its offset
    if (productAddElement.length === 0) {
      return; // Exit early if element doesn't exist
    }

    var block1Bottom =
      productAddElement.offset().top + productAddElement.outerHeight();
    var viewportTop = $(window).scrollTop();

    if (block1Bottom <= viewportTop) {
      $(".product-sticky").addClass("product-sticky--active");
    } else {
      $(".product-sticky").removeClass("product-sticky--active");
    }
  });
});
